var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plugin_que_show"},_vm._l((_vm.que),function(single_item,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(single_item)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }